import { defineComponent, computed } from "vue";
import { u as useComponentPresetProp } from "../../composables/useComponentPreset-0dfbd395.mjs";
import { u as useColors } from "../../composables/useColors-6d98be99.mjs";
const prefixClass = "va-divider";
const _sfc_main = defineComponent({
  name: "VaDivider",
  props: {
    ...useComponentPresetProp,
    vertical: { type: Boolean, default: false },
    dashed: { type: Boolean, default: false },
    inset: { type: Boolean, default: false },
    orientation: {
      type: String,
      default: "center",
      validator: (value) => ["left", "right", "center"].includes(value)
    },
    color: { type: String, default: "backgroundBorder" }
  },
  setup(props, { slots }) {
    const { getColor } = useColors();
    const colorComputed = computed(() => getColor(props.color));
    return {
      colorComputed,
      hasSlot: computed(() => !!slots.default),
      classComputed: computed(() => ({
        [`${prefixClass}--vertical`]: props.vertical,
        [`${prefixClass}--inset`]: props.inset,
        [`${prefixClass}--${props.orientation}`]: props.orientation && !props.vertical,
        [`${prefixClass}--dashed`]: props.dashed
      }))
    };
  }
});
export {
  _sfc_main as _
};

import '../../../VaDivider.css';
//# sourceMappingURL=VaDivider.vue_vue_type_script_lang-4b90507d.mjs.map
